module.exports = __webpack_public_path__ + "img/benefit_store_logo_mono.17f7a660.svg";